<template>
  <svg viewBox="0 0 1024 1024" fill="currentColor">
    <path
      d="M832 768v64H192v-64H128v128h768v-128zM822.624 438.624l-45.248-45.248L544 626.752V128h-64v498.752l-233.376-233.376-45.248 45.248L512 749.248z"
    />
  </svg>
</template>
